import { graphql } from "@opensea/graphql"
import { ContentBlockCarouselFragment } from "./components/ContentBlockCarousel/ContentBlockCarousel.fragment"

export const ContentBlockModuleFragment = graphql(
  `
    fragment ContentBlockModule on CollectionContentBlockModule {
      title
      description
      ...ContentBlockCarousel
    }
  `,
  [ContentBlockCarouselFragment],
)
